
webpack.register(
    'components/dropdown/dropdown-container/dropdown-container',
    function() {
        return require('components/dropdown/dropdown-container/dropdown-container');
    },
    false
);
webpack.register(
    'components/dropdown/dropdown-link/dropdown-link',
    function() {
        return require('components/dropdown/dropdown-link/dropdown-link');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/dropdown/dropdown-container/dropdown-container' />\r\n<can-import from='components/dropdown/dropdown-link/dropdown-link' />\r\n<div class=\"c-video-tabs\">\r\n    <dropdown-container expand-extra-large expand-large expand-medium align-right>\r\n        {{#each tabs}}\r\n            <dropdown-link strategy=\"in\" url=\"{{url}}\" title=\"{{title}}\"></dropdown-link>\r\n        {{/each}}\r\n    </dropdown-container>\r\n</div>");